import { SmallText, StrongText } from '@sb1/ffe-core-react';
import { Label } from '@sb1/ffe-form-react';
import { Icon } from '@sb1/ffe-icons-react';
import styles from '../project-info-box/ProjectInfoBox.module.less';
import { ActionButton } from '@sb1/ffe-buttons-react';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import { formatMoneyKr, formatNumber, pluralize } from '../../../utils';
import cart from '@sb1/ffe-icons/icons/open/300/md/shopping_cart.svg';

export const CartSupportButtons = ({ cartSum, cartCount, navigateToCart }) => {
    return (
        <div className={styles.supportWrapper}>
            <div className={styles.cartSumWrapper}>
                <SmallText className={styles.cartCount}>
                    {formatNumber(cartCount)} {pluralize(cartCount, 'vare', 'varer')}
                </SmallText>
                <StrongText className={styles.cartSum}>Sum: {formatMoneyKr(cartSum)}</StrongText>
            </div>
            <ActionButton
                className={styles.button}
                onClick={() => {
                    trackEvent('shoppingcart-checkout', 'click', {
                        'button-text': 'Støtt',
                        buttonType: 'main',
                    });
                    navigateToCart();
                }}
                size="lg"
            >
                <Icon fileUrl={cart} className={styles.handlevogn} />
                <Label className={styles.buttonLabel}>Til&nbsp;kassen</Label>
            </ActionButton>
        </div>
    );
};
